import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buyer-menu',
  templateUrl: './buyer-menu.component.html'
})
export class BuyerMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
